import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { doUnlinkLinearIssue } from 'ducks/integrations/linear'

export function useLinearIssueActions(issue, doCloseIssueView) {
  const dispatch = useDispatch()
  return useMemo(
    () => {
      if (!issue?.id && !issue?.externalId) return []
      return [
        {
          action: () => {
            dispatch(doUnlinkLinearIssue(issue))
            doCloseIssueView()
          },
          text: 'Unlink',
        },
        issue.url && {
          blankTarget: true,
          text: 'Open in Linear',
          url: issue.url,
        },
      ].filter(Boolean)
    },
    [dispatch, doCloseIssueView, issue]
  )
}
